
enum ShipmentUpdateType{
    ADD = "ADD",
    TAKE_FROM = "TAKE_FROM"
}
export default ShipmentUpdateType
